import { render, staticRenderFns } from "./InsulinDeliverySettingTable.vue?vue&type=template&id=4b6c5fab&scoped=true"
import script from "./InsulinDeliverySettingTable.vue?vue&type=script&lang=js"
export * from "./InsulinDeliverySettingTable.vue?vue&type=script&lang=js"
import style0 from "./InsulinDeliverySettingTable.vue?vue&type=style&index=0&id=4b6c5fab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c5fab",
  null
  
)

export default component.exports